import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { requireSystemAdmin } from '~/utils/guards';

/**
 * Create/edit connection form route
 * (`/integrations/connections/connect/$connectorCode`). Presence of the
 * `connectionId` search param switches the form into edit mode. Super-admin
 * only, matching the connections management page it's launched from.
 */
const ConnectionConnectPage = lazy(
  () => import('~/features/integrations/pages/connection-connect-page'),
);

const searchSchema = z.object({
  connectionId: z.string().optional(),
  sc: z.string().optional(),
});

export const Route = createFileRoute(
  '/_authenticated/_tenant/integrations/connections/connect/$connectorCode',
)({
  validateSearch: searchSchema,
  beforeLoad: requireSystemAdmin(),
  component: RouteComponent,
});

function RouteComponent() {
  const { connectorCode } = Route.useParams();
  const { connectionId, sc } = Route.useSearch();
  return (
    <Suspense fallback={<PageSkeleton />}>
      <ConnectionConnectPage
        connectorCode={connectorCode}
        connectionId={connectionId}
        subsidiaryId={sc}
      />
    </Suspense>
  );
}
